import React, { Component } from 'react';
import styled from 'styled-components';
import SkinAnalysisItem from './SkinAnalysisItem';
import { inStoreIconSetup as iconSetup, sumMeasures, rgbToHex } from '../../utils';
import SkinAnalysisIcons from './SkinAnalysisIcons';
import { translate } from 'react-polyglot';

const StyledSkinAnalysisWidget = styled.div`
  background: rgba(0, 0, 0, 0.7);
  border-radius: 8px;
  height: 120px;
  display: flex;
  align-items: center;
  position: absolute;
  /* left: 30px; */
  min-width: 100%;
`;

const StyledInfoText = styled.div`
  width: 100%;
  position: absolute;
  bottom: 140px;
  padding-left: 18px;
  color: white;
  font-size: small;
`;

function generateIcons({
  data,
  iconSetup,
  focusOnHandler,
  focusedFinding,
  showOnly,
  showRange = false,
  skintoneValue,
  t,
  ranges,
}) {
  let icons = [];
  for (let iconName of Object.keys(iconSetup)) {
    if (showOnly && Array.isArray(showOnly) && showOnly.indexOf(iconName) < 0) {
      continue;
    }

    let icon = iconSetup[iconName];

    if (data.hasOwnProperty(icon.key) && data[icon.key].hasOwnProperty('sum_measures')) {
      let r = data[icon.key].sum_measures.find(d => {
        return d.description === icon.withDescription;
      });
      let localWarnings =
        data[icon.key].local_warnings && data[icon.key].local_warnings.length > 0
          ? data[icon.key].local_warnings
          : null;

      // let d = data[icon.key].hasOwnProperty('measurement_locations') ? data[icon.key]['measurement_locations'] : null;
      let value;
      if (icon.key === icon.withDescription) {
        //in case of wrinkles or redness we take the value provided by CV
        value = data[icon.key].value;
      } else {
        value = r ? r.value : 'NA';
      }
      let rangeColor = null;
      if (icon.enum && icon.enum.hasOwnProperty(String(value))) {
        value = icon.enum[value];
      } else if (showRange && icon.range) {
        // we need to detect the range for this value
        for (const rangeName in icon.range) {
          if (icon.range[rangeName]) {
            const rangeInfo = icon.range[rangeName];
            if (value >= rangeInfo.min && value <= rangeInfo.max) {
              value = t('range_' + rangeName).toUpperCase();
              rangeColor = rangeInfo.color;
              break;
            }
          }
        }
      } else if (icon.type === 'skintoneColor') {
        value = rgbToHex(value[0]);
      } else if (isNaN(value)) {
        //value = 'NA';
      } else {
        value = (value * 100).toFixed(0) + '%';
      }

      icons.push(
        <SkinAnalysisItem
          key={iconName}
          value={value}
          rangeColor={rangeColor}
          icon={icon.icon}
          label={icon.label}
          selected={iconName === focusedFinding}
          onClick={() => {
            if (ranges && ranges[iconName]) {
              focusOnHandler(iconName, null, ranges[iconName]);
            } else {
              focusOnHandler(iconName);
            }
          }}
          warnings={localWarnings}
        />,
      );
    }
    //Skintone value isn't present in results. We need to get it from SDK
    if (icon.type === 'skintone') {
      let value = skintoneValue;
      value = icon.enum[value];
      icons.push(
        <SkinAnalysisItem
          key={iconName}
          value={value}
          icon={icon.icon}
          label={iconName}
          selected={iconName === focusedFinding}
          onClick={() => {
            focusOnHandler(iconName);
          }}
        />,
      );
    }
  }
  return icons;
}

class SkinAnalysisWidget extends Component {
  componentDidMount = () => {
    const { options, focusOnSkinFinding, setSkinAnalysisPageRendered } = this.props;
    if (options.focusOn) {
      setTimeout(() => {
        if (options.ranges && options.ranges[options.focusOn]) {
          focusOnSkinFinding(options.focusOn, null, options.ranges[options.focusOn]);
        } else {
          focusOnSkinFinding(options.focusOn);
        }
        setSkinAnalysisPageRendered();
      }, 500);
    }
  };

  render = () => {
    const { cvResults, focusOnSkinFinding, focusedOnSkinFinding, options, ARMethods, t } = this.props;
    if (cvResults && cvResults.results) {
      let resultSumMeasures = sumMeasures(cvResults.results);
      let icons = generateIcons({
        data: resultSumMeasures,
        iconSetup,
        focusOnHandler: focusOnSkinFinding,
        focusedFinding: focusedOnSkinFinding,
        showOnly: options.showOnly,
        showRange: options.showRange,
        skintoneValue: ARMethods.getSdkSkintone(),
        t,
        ranges: options.ranges,
      });
      return (
        <div>
          {options.infoText && <StyledInfoText> {options.infoText} </StyledInfoText>}
          <StyledSkinAnalysisWidget className="revieve-skin-analysis-widget">{icons}</StyledSkinAnalysisWidget>
        </div>
      );
    }

    return (
      <StyledSkinAnalysisWidget className="revieve-skin-analysis-widget">
        <SkinAnalysisItem
          value={'Diamond'}
          icon={SkinAnalysisIcons.shape}
          label={'Test1'}
          selected={'Diamond' === focusedOnSkinFinding}
          onClick={() => {
            focusOnSkinFinding('Diamond', {});
          }}
        />
        <SkinAnalysisItem value={'Green'} icon={SkinAnalysisIcons.eyecolor} label={'Test2'} />
        <SkinAnalysisItem value={'21%'} icon={SkinAnalysisIcons.darkcircles} label={'Test3'} />
      </StyledSkinAnalysisWidget>
    );
  };
}

export default translate()(SkinAnalysisWidget);



// WEBPACK FOOTER //
// ./src/components/instore/SkinAnalysisWidget.js